var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#77928B",
    fillRule: "evenodd",
    d: "M5.592 7.456c-1.03 0-1.864-.835-1.864-1.864 0-1.03.834-1.864 1.864-1.864 1.03 0 1.864.834 1.864 1.864 0 .494-.197.968-.546 1.318-.35.35-.824.546-1.318.546zm0-2.486c-.343 0-.622.279-.622.622 0 .343.279.621.622.621.343 0 .621-.278.621-.621 0-.343-.278-.622-.621-.622zm0 9.941c-.165.001-.324-.064-.441-.18C4.97 14.52 0 9.531 0 5.591 0 2.504 2.503 0 5.592 0c3.088 0 5.591 2.503 5.591 5.592 0 3.939-4.97 8.928-5.15 9.14-.117.115-.276.18-.441.18zm0-13.668c-2.402 0-4.35 1.947-4.35 4.349 0 2.802 3.163 6.505 4.35 7.797C6.778 12.103 9.94 8.42 9.94 5.592c0-2.402-1.947-4.35-4.35-4.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.fbd0d5289f08c71d403f2e78b568435e.svg";
export { ForwardRef as ReactComponent };